import styled from 'styled-components'

const Container = styled.div`
    .product-block{
        .col-50{
            width: 30% !important;
            margin-left: 50px;
        }
        .MuiAccordionSummary-root.Mui-focusVisible {
            background-color: transparent;
        }
    }
    .product-block-details {
        grid-template-columns: auto;
        @media (max-width: 1250px) {
        grid-template-columns: auto;
        }
      .payment-initiation-date-style{
        display: flex;
        max-width: fit-content;
        font-size: 15px;
        color: #68a107;
        padding: 10px;
        background-color: #f9f9f9;
        border-radius: 4px;
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
        margin-bottom: 5px;
        border: 1px solid #d8d1d1;
        border-top: none;
        border-left: none;
        font-family: 'latoregular';
        font-weight: 100;
      }  
    }
`;

export { Container };